export default __webpack_public_path__ + "static/media/room-view-2.9d479d5f.jpg";